//7import Vue from "vue";
import * as VueGoogleMaps from 'vue2-google-maps';

// "async" is optional;
// more info on params: https://quasar.dev/quasar-cli/boot-files
export default async ({ Vue } /* { app, router, Vue ... } */) => {
  Vue.use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyA1_so-Ym6BM032tcw_A3ymfmf0bT-ylDs',
      libraries: 'places',
      region: 'CO',
      language: 'es'
    },
    installComponents: true
  });
};
